<template>
    <div class="modal fade" id="trsNewsInfoModal" tabindex="-1" role="dialog" aria-labelledby="trsNewsInfoModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div v-for="(item, index) in options" :key="item.messageId">
                    <div v-if="!item.isHidden" :class="item.messageId">
                        <div class="modal-header">
                            <h5 class="modal-title" id="trsNewsInfoModalLabel" style="word-break: break-word">
                                {{ item.messageTitle }}
                            </h5>
                            <div class="news-meta">
                                <span class="news-date">{{ item.startDate | formatDate("DD-MM-YYYY hh:mm:ss", "YYYY/MM/DD") }}</span>
                                <span :class="colorMessageKind(item.messageKind)">{{ item.messageKind | textMessageKind }}</span>
                                <span class="notify-cat"><strong>{{ item.serviceType | textServiceTypePopup }}</strong></span>
                            </div>
                            <div class="modal-body" id="modal-body" v-html="item.information"></div>
                        </div>
                        <div class="modal-footer">
                            <template v-if="!isAgreementNew">
                                <!-- news info only display one news at a time-->
                                <template v-if="isCloseBtn(options[0])">
                                    <button type="button" class="btn btn-success " @click="hide">
                                        {{  $t("btn.close") }}
                                    </button>
                                </template>
                                <template v-else>
                                    <button type="button" class="btn btn-success" @click="hide">
                                        {{ item.buttonActionText }}
                                    </button>
                                </template>
                            </template>
                            <template v-else>
                                <button type="button" class="btn btn-success " @click="hideAgreementBlock(index)">
                                    {{ item.buttonActionText || $t("btn.close")}}
                                </button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import $ from "jquery";

export default {
    name: "NewsInfoModal",
    data() {
        return {
            options: {},
            isAgreementNew: false,
            callbackFunction: null
        }
    },
    mounted() {
        ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_NEWS_INFO, (options) => {
            this.show(options);
        });
    },
    methods: {
        show(options) {
            $("#trsNewsInfoModal").modal({
                show: true,
                backdrop: 'static',
                keyboard: false
            });
            this.options = options.item.map(item => ({
                ...item,
                isHidden: item.isHidden || false,
            }));
            this.isAgreementNew = options.isAgreementNew;
            this.callbackFunction = options.callbackFunction;
        },
        hide() {
            if (this.callbackFunction) this.callbackFunction();
            $("#trsNewsInfoModal").modal("hide");
        },
        hideAgreementBlock(index) {
            if (this.callbackFunction) this.callbackFunction(this.options[index].messageId);

            this.$set(this.options[index], 'isHidden', true);

            const visibleBlocks = this.options.filter(option => !option.isHidden);
            if (visibleBlocks.length === 0) {
                $("#trsNewsInfoModal").modal("hide");
            }
        },
    },
};
</script>

<style scoped>
.modal-header {
    flex-direction: column;
    border-bottom: none;
}
.modal-footer {
    border-top: none;
    border-bottom: 1px solid #dee2e6;
}
.news-date {
  margin-right: 5px;
}
.modal-body {
  width: -webkit-fill-available; /* Chrome and IE.
  width: intrinsic;           /* Safari/WebKit uses a non-standard name */
  width: -moz-available;    /* Firefox/Gecko */
  word-break: break-word;
}
</style>
